import { Sort } from '@angular/material/sort';
import { Action } from '@ngrx/store';
import { DefaultViewFilterSto } from '../../../shared/models/default-view-filter.model';
import { IncomingTopicsSto, RelatedObjectSto } from '../models/incoming-topic.model';

export const REHYDRATE = '[Incoming Topics] Rehydrate';
export const DEHYDRATE = '[Incoming Topics] Dehydrate';

export class RehydrateServiceVans implements Action {
  readonly type = REHYDRATE;
}

export class DehydrateServiceVans implements Action {
  readonly type = DEHYDRATE;
}

//-------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------
export const LOAD_SUCCESS = '[Incoming Topics] Load incoming topics successful';
export const LOAD_FAILED = '[Incoming Topics] Load incoming topics failed';
export const LOAD_STOPPED = '[Incoming Topics] Load incoming topics stopped. Store data already existing.';

export class LoadIncomingTopicsSuccessful implements Action {
  readonly type = LOAD_SUCCESS;
}

export class LoadIncomingTopicsFailed implements Action {
  readonly type = LOAD_FAILED;
}

export class LoadIncomingTopicsStopped implements Action {
  readonly type = LOAD_STOPPED;
}

//-------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------
export const LOAD_PAGE = '[Incoming Topics] Load incoming topics page';
export const LOAD_PAGE_SUCCESS = '[Incoming Topics] Load incoming topics page successful';
export const LOAD_PAGE_FAILURE = '[Incoming Topics] Load incoming topics page failed';

export class LoadIncomingTopicsPage implements Action {
  readonly type = LOAD_PAGE;
  constructor(public payload: { viewId: string; viewFilter: DefaultViewFilterSto; sort: Sort; offset: number }) {}
}

export class LoadIncomingTopicsPageSuccessful implements Action {
  readonly type = LOAD_PAGE_SUCCESS;
  constructor(
    public payload: {
      viewId: string;
      topics: IncomingTopicsSto[];
      topicsTotalCount: number;
      related: RelatedObjectSto[];
      viewFilter: DefaultViewFilterSto;
      offset: number;
    }
  ) {}
}

export class LoadIncomingTopicsPageFailed implements Action {
  readonly type = LOAD_PAGE_FAILURE;
  constructor(public payload: { viewId: string }) {}
}

//-------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------
export const ACKNOWLEDGE_SUCCESS = '[Incoming Topics] Send acknowledge successful';
export const ACKNOWLEDGE_FAILED = '[Incoming Topics] Send acknowledge failed';
export const ACKNOWLEDGE = '[Incoming Topics] Send acknowledge';

export class AcknowledgeIncomingTopicsSuccessful implements Action {
  readonly type = ACKNOWLEDGE_SUCCESS;
  constructor(public payload: { aggregateId: string; subEventIds: string[]; dismissed: boolean }) {}
}

export class AcknowledgeIncomingTopicsFailed implements Action {
  readonly type = ACKNOWLEDGE_FAILED;
}

export class AcknowledgeIncomingTopics implements Action {
  readonly type = ACKNOWLEDGE;
  constructor(public payload: { aggregateId: string; subEventIds: string[]; dismissed: boolean }) {}
}

//-------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------
export const LOAD_DETAILS = '[Incoming Topics] Load incoming topic details';
export const LOAD_DETAILS_SUCCESS = '[Incoming Topics] Load incoming topic details successful';
export const LOAD_DETAILS_FAILURE = '[Incoming Topics] Load incoming topic details failed';

export class LoadIncomingTopicDetails implements Action {
  readonly type = LOAD_DETAILS;
  constructor(public payload: { aggregateId: string }) {}
}

export class LoadIncomingTopicDetailsSuccessful implements Action {
  readonly type = LOAD_DETAILS_SUCCESS;
  constructor(public payload: { topic: IncomingTopicsSto; related: RelatedObjectSto[] }) {}
}

export class LoadIncomingTopicDetailsFailed implements Action {
  readonly type = LOAD_DETAILS_FAILURE;
}

export type Actions =
  | LoadIncomingTopicsSuccessful
  | LoadIncomingTopicsFailed
  | LoadIncomingTopicsStopped
  | LoadIncomingTopicsPage
  | LoadIncomingTopicsPageSuccessful
  | LoadIncomingTopicsPageFailed
  | AcknowledgeIncomingTopics
  | AcknowledgeIncomingTopicsFailed
  | AcknowledgeIncomingTopicsSuccessful
  | LoadIncomingTopicDetails
  | LoadIncomingTopicDetailsFailed
  | LoadIncomingTopicDetailsSuccessful;
